import { render } from "./TeamMembersEditor.vue?vue&type=template&id=0a26b4e4&scoped=true"
import script from "./TeamMembersEditor.vue?vue&type=script&lang=js"
export * from "./TeamMembersEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a26b4e4"]])

export default __exports__